// extracted by mini-css-extract-plugin
module.exports = {"grid":"changePassword_grid__3LMS4","header":"changePassword_header__v_Yjk"};